import React, { useState } from 'react'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'

import { KpiForm } from './components'

const KpiNew = () => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <Page title="Criação de Projeto - Monitoramento">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="KPI" />
        <KpiForm />
      </Container>
    </Page>
  )
}

export default KpiNew
